/**
 * 医院选择器
 *
 */

'use strict'

import Vue from 'vue';
import Component from "vue-class-component";

@Component
class hospitalSelector extends Vue {

	hospitalData = [] //医院
	sectionData = []  //科室
	keyword2 = '' // 搜索
	provinceId = '' //
	cityId = '' // 城市id   app/web  get方式不一样
	tenant_id = '' //租户id  app/web  get方式不一样

	//获取上线医院
	async QueryHospitalConfig(obj) {
		if(obj && obj.type == 'web'){
			this.provinceId = obj.provinceId || this.provinceId || '';
			this.cityId = obj.cityId || this.cityId || '';
			this.tenant_id = this.iStorage.get('tenant_id') || '';
			this.pageIndex = obj.pageIndex || this.pageIndex;
			this.pageSize = obj.pageSize || this.pageSize;
			this.keyword2 = obj.keyword
		}else{
			this.provinceId = this.$store.state.cityForm.provinceId;
			this.cityId = this.$store.state.cityForm.cityId;
			this.tenant_id = this.$cookies.getCookie('tenant_id');
		}
		var params = {
			cityId: this.cityId,
			searchInput: this.keyword2,
			pageIndex: this.pageIndex,
			pageSize: this.pageSize,
			provinceId: this.provinceId,
			tenantId: this.tenant_id
		}
		var response = await this.api.post(this.url.mice.PagingHospital, params);
		if(obj && obj.type == 'web'){
			this.hospitalData = response.rows;
			this.hospitalTotal = response.total;
			return false;
		}
		if(this.pageIndex == 1){
			this.hospitalData = this.hospitalList = [];
		}
		this.hospitalData = this.hospitalList = this.hospitalList.concat(response.rows);
		if(this.hospitalList.length == response.total) {
			this.allLoaded = true;
		}
		this.hospitalList.map((ele) => {
			ele.active = false;
		})
		this.selected();
	}

	//获取科室
	async FnDictionaryQuery() {
		var params = {
			keyCode: 'HospitalDepartment',
			keyword: this.keyword2
		}
		var response = await this.api.post(this.url.dictionary.query, params);
		this.allLoaded = true;
		this.sectionData = this.hospitalList = response.content || [];
		this.hospitalList.map((ele) => {
			ele.active = false;
		})
		this.selected();
	}
}

export default hospitalSelector;



// WEBPACK FOOTER //
// ../scripts/components/hospitalSelector.js